import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_65: FaireProductEntity = {
  token: "catalog_prod_prod-65",
  type: "product",
  name: "Paper Pendant Light - Accordion Fold - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 103.29,
  msrpDollars: 258.23,
  sku: "JA0065",
  caseSize: 3,
  material: "Ceramic",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 162,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_coffee-tea"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
